"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _constants = require("./constants");
const Spinner = _ref => {
  let {
    clientId,
    color,
    initialDelay,
    size = "medium",
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const [visible, setVisible] = (0, _react.useState)(initialDelay === undefined);
  (0, _react.useEffect)(() => {
    if (initialDelay) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, initialDelay);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [initialDelay]);
  return /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    size: size
  }, rest, {
    "data-client-id": clientId
  }), visible && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TopDot, {
    color: color,
    size: size,
    themeMode: themeMode
  }), /*#__PURE__*/_react.default.createElement(BottomDot, {
    color: color,
    size: size,
    themeMode: themeMode
  })));
};
exports.Spinner = Spinner;
const getCubeAnimation = (containerWidth, dotSize) => {
  const delta = `${containerWidth - dotSize}px`;
  return (0, _core.keyframes)`
    25% {
        transform: translate(${delta}, 0);
    }
    50% {
        transform: translate(${delta}, ${delta});
    }
    75% {
        transform: translate(0, ${delta});
    }
    100% {
        transform: translate(0, 0);
    }
`;
};
const LayoutStyles = (0, _core.css)`
    box-sizing: border-box;
`;
const Container = (0, _styled.default)("div")`
    ${LayoutStyles};

    display: block;
    font-size: 0;
    height: ${props => _constants.SPINNER_CONTAINER_SIZES_MAP[props.size]}px;
    width: ${props => _constants.SPINNER_CONTAINER_SIZES_MAP[props.size]}px;
    position: relative;
    pointer-events: none;
`;
const dotTheme = (0, _sdsThemeInternal.themed)({
  color: {
    "lodestar-light": (0, _designTokensReact.color)("color--text--neutral--strong"),
    "ursa-light": "currentColor"
  }
});
const TopDot = (0, _styled.default)("div")`
    ${LayoutStyles};

    background-color: ${_ref2 => {
  let {
    color,
    themeMode
  } = _ref2;
  return color || dotTheme.color(themeMode);
}};
    width: ${props => _constants.SPINNER_DOT_SIZES_MAP[props.size]}px;
    height: ${props => _constants.SPINNER_DOT_SIZES_MAP[props.size]}px;
    display: inline-block;
    float: none;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 50%;
    animation: ${props => getCubeAnimation(_constants.SPINNER_CONTAINER_SIZES_MAP[props.size], _constants.SPINNER_DOT_SIZES_MAP[props.size])}
        1.6s 0s infinite cubic-bezier(0.2, 0, 0, 1);
`;
const BottomDot = (0, _styled.default)(TopDot)`
    animation-delay: -0.8s;
`;
//# sourceMappingURL=Spinner.js.map